import { render } from "./campus.vue?vue&type=template&id=06c3856f"
import script from "./campus.vue?vue&type=script&lang=js"
export * from "./campus.vue?vue&type=script&lang=js"
script.render = render

export default script